import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import {
  Add,
  BlankCard,
  Community,
  Equal,
  VerticalLabelValue,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import CareNavigatorConstants from '../core-utils/messages/CareNavigatorConstants';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import PptReportTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/PptReportTable';
import { cellStyles1, headerStyles1 } from './ClaimantsDistribution';
import { numberToCurrencyFormatter } from '../core-utils/helper-utils/helper';
import { reportProps } from './StopLossAggregateTable';

const CareNavigationMembers: React.FC<reportProps> = ({ data }) => {
  const messages = CareNavigatorConstants.QUARTERLY_REPORT;
  const iconStyle = { height: '18px', width: '18px' };
  const useStyles = makeStyles()({
    container: {
      flexDirection: 'column',
      gap: '15px',
    },
  });
  const { classes } = useStyles();

  const [tableData, setTableData] = useState<any>();
  const [
    tableAlternateColorRowsIndex,
    setTableAlternateColorRowsIndex,
  ] = useState<any>();
  const claimantsColumns: any[] = [
    {
      name: 'MEMBER ID',
      align: 'left',
      width: '120px',
    },
    {
      name: 'GENDER',
      align: 'left',
      width: '80px',
    },
    {
      name: 'AGE',
      align: 'left',
      width: '40px',
    },
    {
      name: 'RELATIONSHIP',
      align: 'left',
      width: '100px',
    },
    {
      name: 'DIAGNOSIS',
      align: 'left',
      width: '950px',
    },
    {
      name: 'TYPE OF ENGAGEMENT',
      align: 'left',
      width: '100px',
    },
    {
      name: 'ENGAGED / NOT ENGAGED',
      align: 'left',
      width: '130px',
    },
    {
      name: 'PLAN PAID',
      align: 'right',
      width: '100px',
    },
  ];

  const formatTableData = async (data: any) => {
    const alternateColorRows: number[] = [];
    const formattedData = data?.map((item: any, index: number) => {
      if (item?.isInTopTenPercent) {
        alternateColorRows.push(index);
      }
      return [
        item?.member_id,
        item?.gender,
        item?.age,
        item?.member_relationship_desc,
        item?.diagnosis?.length
          ? item?.diagnosis
              ?.map((val: any) => {
                return `${val.description} - ${numberToCurrencyFormatter(
                  val.plan_paid,
                )}`;
              })
              .join(',')
          : '-',
        item?.caseTypes?.length ? item?.caseTypes?.join(',') : '-',
        item?.engaged ? 'Engaged' : 'Not Engaged',
        numberToCurrencyFormatter(item?.planPaid),
      ];
    });
    setTableAlternateColorRowsIndex(alternateColorRows);
    setTableData(formattedData);
  };

  useEffect(() => {
    formatTableData(data?.careNavigationMoi?.patientsWithPlanPaid);
  }, []);

  return (
    <>
      <Grid container className={classes.container}>
        {data?.careNavigationMoi?.totalPatients !== 0 && (
          <BlankCard
            mainGridStyles={{ padding: '0px 24px', width: '80%' }}
            body={
              <Grid
                container
                style={{ gap: '10px' }}
                sx={{
                  alignItems: 'center',
                }}
              >
                <Community />
                <VerticalLabelValue
                  title={messages.totalMembers}
                  value={data?.careNavigationMoi?.totalPatients?.toString()}
                  rootStyles={{ width: '220px' }}
                />
                {data?.careNavigationMoi?.categoryCounts?.length > 0 && (
                  <>
                    <Equal style={iconStyle} />
                    {data?.careNavigationMoi?.categoryCounts?.map(
                      (item: any, index: number) => (
                        <>
                          {index !== 0 && (
                            <Add
                              stroke={patientAccessTheme.palette.status.icon}
                              fill={patientAccessTheme.palette.status.icon}
                              style={iconStyle}
                            />
                          )}
                          <VerticalLabelValue
                            title={item?.category}
                            value={item?.count?.toString() ?? '0'}
                          />
                        </>
                      ),
                    )}
                  </>
                )}
              </Grid>
            }
          />
        )}
        {tableData?.length > 0 && (
          <PptReportTable
            data={tableData}
            columns={claimantsColumns}
            cellStyles={cellStyles1}
            headerStyles={headerStyles1}
            alternateColorRowsIndex={tableAlternateColorRowsIndex}
            alternateRowColor="#EEF0E5"
          />
        )}
      </Grid>
    </>
  );
};
export default CareNavigationMembers;
